import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { OptionTranslateService } from '../../../../shared/services/option-translate.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { Utils } from '../../../../Utils/utils';
import { customValidator, normalizeIban } from '../../../../Utils/validator';
import { ApiRoot, ApiEndPoints } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { Subject, debounceTime, distinctUntilChanged, filter, finalize, iif, switchMap, tap } from 'rxjs';
import { LookupService } from '../../../../core/services/lookup.service';
import { LOVResponseModel } from '../../../../shared/models/lov-response.model';
import { AllowedDocumentType, FolderResponse } from '../../../../shared/models/documents-response.model';
import { DocumentServiceType, FieldValue, ServiceName, SrActionType, SrIOName } from '../../../../shared/constants/services.enum';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { ChamberEntrepreneurshipRequest } from '../../../../shared/models/services-request/chamber-entrepreneurship.model';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { SrStatus } from '../../../../shared/constants/status.enum';
import { LinkMemberRequest } from '../../../../shared/models/services-request/link-member.model';
import { PendingSrModalComponent } from "../../../../shared/components/pending-sr-modal/pending-sr-modal.component";
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-chamber-entrepreneurship',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, SkeletonLoaderComponent, DatePipe, SrSubmitSuccessModalComponent, PendingSrModalComponent],
  templateUrl: './chamber-entrepreneurship.component.html',
  styleUrl: './chamber-entrepreneurship.component.scss'
})
export class ChamberEntrepreneurshipComponent implements OnInit {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  form: FormGroup;
  supportForm: FormGroup;
  lookupKey = LookupKey;
  lang: any = 'en';
  userLoginName: string = '';
  memberCSN: string = '';
  standardOption: any = [];
  dcParamsOptions: any[] = [];
  trainingWorkshopsOptions: any[] = [];
  strategicProgramsOptions: any[] = [];
  serviceSupportOptions: any[] = [];
  members: any = [];
  loadingMember: boolean = false;
  private preload: any[] = [];
  private search$ = new Subject<any>();
  memberDetail: any;
  documentServiceType = DocumentServiceType;
  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  supportFormDocs: AllowedDocumentType[] = [];
  loadingDoc = false;
  showBusinessSupportSections = true;
  totalSteps = 5;
  step = 1;
  showSupportServiceForm: boolean = false;
  showEntrepreneurshipForm: boolean = true;
  emiratesIdLookupRequired = false;
  emiratesIdFound = true;
  licenseIssueDateInvalid = false;
  detLicenseAuthorityInvalid = false;
  ownerPartnerNationalityInvalid = false;
  emiratesIdChecked = false;
  emiratesIdChecking = false;
  selectedMemberCSN: string = "";
  srNumber: string = "";
  srDetailLoading = false;
  licIssueMinDate: Date | null = null;
  showNotes: boolean = false;
  srInprgoressAwating: boolean = false;
  showActions: boolean = true;
  showSupportAtLeastOneError: boolean = false;
  showInKindLeastOneError: boolean = false;
  memberSearchByOptions = [
    { value: 'CSN', label: 'SEARCH_BY_MEM_NUMBER' },
    { value: 'LicenseNumber', label: 'SEARCH_BY_MEM_LICENSE' }
  ];
  private enTranslations: Record<string, any> = {};

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private sharedService: SharedService,
    private optionTranslateService: OptionTranslateService,
    private api: ApiService,
    private cdr: ChangeDetectorRef,
    private lookupService: LookupService,
    private translate: TranslateService,
    private route: ActivatedRoute
  ) {
    this.lang = this.sharedService.getCurrentLang();
    this.userLoginName = this.sharedService.getUserProfile()['Login Name'];
    this.memberCSN = this.sharedService.getCsnAccountId('csn');
    this.standardOption = this.optionTranslateService.getOptions(
      'standardOption',
      this.lang
    );

    this.form = this.fb.group({
      uaeNational: [{ disabled: true, value: 'Yes' }],
      firstName: [{ disabled: true, value: '' }, [Validators.required]],
      lastName: [{ disabled: true, value: '' }, [Validators.required]],
      emiratesIdNumber: [null, [customValidator('emiratesId'), Validators.maxLength(20)]],
      mobileCountryCode: [''],
      mobileNumber: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      tradeLicenseOrMembershipNumber: ['', [Validators.required]],
      tradeNameEnglish: [{ disabled: true, value: '' }, [Validators.required]],
      tradeNameArabic: [{ disabled: true, value: '' }, [Validators.required]],
      licenseIssueDate: this.fb.group({
        day: [{ disabled: true, value: null }],
        month: [{ disabled: true, value: null }],
        year: [{ disabled: true, value: null }],
      }),
      licenseExpiryDate: this.fb.group({
        day: [{ disabled: true, value: null }],
        month: [{ disabled: true, value: null }],
        year: [{ disabled: true, value: null }],
      }),

      briefBusinessDescription: ['', [Validators.required, Validators.maxLength(1000)]],
      companyNationality: [{ disabled: true, value: null }, [Validators.required]],
      numberOfEmployees: ['', [customValidator('numberOnly'), Validators.maxLength(10)]],
      otherTradeLicensesUae: ['', [Validators.required]],
      companyWebsite: ['', [customValidator('websiteLink')]],
      bankName: ['', [Validators.required]],
      otherBankName: [''],
      companyIban: ['', [Validators.required, Validators.maxLength(34), customValidator('iban')]],
      accountHolderName: ['', [Validators.required, Validators.maxLength(150)]],
      accountNumber: ['', [Validators.required]],
      swiftCode: ['', [Validators.required]],
      confirmInformation: [null, [Validators.required]]
    });

    this.supportForm = this.fb.group({
      tradeLicenseCost: [''],
      visaProcessingCost: [''],
      dewaCost: [''],
      vatSupport: [''],
      marketInsights: ['', [Validators.maxLength(1000)]],
      trainingWorkshops: [[]],
      aiCyberTraining: [''],
      strategicPrograms: [[]],
      serviceSupport: [[]]
    });

    this.form.get('companyIban')?.valueChanges.subscribe((value: string | null) => {
      const normalizedValue = normalizeIban(value);
      if (value !== normalizedValue) {
        this.form.get('companyIban')?.setValue(normalizedValue, { emitEvent: false });
      }
    });
  }

  ngOnInit(): void {
    const loginUserDetail = this.sharedService.getUserProfile();
    const userNationality = (loginUserDetail?.['DC Nationality'] || '').trim();
    if (
      userNationality &&
      userNationality !== FieldValue.UAE &&
      userNationality !== FieldValue.UAE_AR
    ) {
      this.sharedService.toastMessage(
        'INFO',
        'ENTREPRENEURSHIP_NATIONALS',
        'info'
      );
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }

    this.sharedService.getSrNumber(this.route).subscribe(srNumber => {
      if (srNumber) {
        this.srNumber = srNumber;
        this.getSrDetail();
      }
    });   

    const hasPhone = !!loginUserDetail?.['Phone #'];
    const mobileNumber = hasPhone
      ? Utils.parseMobile(loginUserDetail['Phone #'], 'number')
      : '';
    const mobileCountryCode = hasPhone
      ? Utils.parseMobile(loginUserDetail['Phone #'], 'cc')
      : '';

    this.emiratesIdLookupRequired = !loginUserDetail?.['Emirates Id'];
    if (this.emiratesIdLookupRequired) {
      const emiratesControl = this.form.get('emiratesIdNumber');
      emiratesControl?.setValidators([
        customValidator('emiratesId'),
        Validators.maxLength(20),
        Validators.required
      ]);
      emiratesControl?.updateValueAndValidity({ emitEvent: false });
    }

    this.form.patchValue(
      {
        firstName: loginUserDetail?.['First Name'] ?? '',
        lastName: loginUserDetail?.['Last Name'] ?? '',
        emiratesIdNumber: loginUserDetail?.['Emirates Id'] ?? '',
        mobileCountryCode: mobileCountryCode ?? '',
        mobileNumber: mobileNumber ?? '',
        email: loginUserDetail?.['EMail Addr'] ?? ''
      },
      { emitEvent: false }
    );
    if (loginUserDetail?.['Emirates Id']) {
      this.form.get('emiratesIdNumber')?.disable({ emitEvent: false })
    }
    this.loadLovOptions(
      LookupKey.DC_DCE_PARAMS,
      'dcParamsOptions'
    );
    this.loadLovOptions(
      LookupKey.DC_DCE_TRAINING_WORKSHP,
      'trainingWorkshopsOptions'
    );
    this.loadLovOptions(
      LookupKey.DC_DCE_STRATEGIC_PROGRAMS,
      'strategicProgramsOptions'
    );
    this.loadLovOptions(
      LookupKey.DC_DCE_ADDN_SERVICES,
      'serviceSupportOptions'
    );

    this.openFolder();

    
    // This is used to check the login member has already DCE Start Date
    const account = this.sharedService.getAccountWithDceStartDate();
    if (account && !this.srNumber) {
      this.srDetailLoading = true;
      // this.router.navigate([RoutesPath.DASHBOARD]);
      this.gotoBusinessSupporOrInkind(account);
      return;
    }

    // Search member subject
    this.search$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap((term: any) => {
          if (term?.searchText && term?.searchText.length <= 0) {
            this.members = this.preload;
          }
        }),
        filter((term) => term?.searchText && term?.searchText.length > 2),
        tap(() => (this.loadingMember = true)),
        switchMap((term: any) =>
          this.getMembers(term.searchText, term.searchBy)
            .pipe(finalize(() => (this.loadingMember = false)))
        )
      )
      .subscribe((response: any) => {
        if (
          response &&
          response['Error Code'] == '' &&
          response['SiebelMessage']?.['DC Account Thin']
        ) {
          const memberData = Utils.checkIsArray(
            response['SiebelMessage']['DC Account Thin']
          );
          this.members = memberData.map((item: any) => ({
            ...item,
            Name: this.lang === 'en' ? item['DC Name English'] : item['DC Name Arabic'],
            Value: item['CSN'] || item['License Number'] || item['License Number Desc']
          }));
          if (!this.preload.length) {
            this.preload = this.members;
          }
        } else {
          this.members = [];
        }
      });
  }

  // This method is use to set the account as selected member to proceed
  async gotoBusinessSupporOrInkind(account: any) {
    this.form.get('tradeLicenseOrMembershipNumber')?.setValue(account.CSN);
    if (account.CSN) {
      this.selectedMemberCSN = account.CSN;
      this.getMemberDetail();
    }

    //hide first form
    this.showEntrepreneurshipForm = false;

    const hasPending = await this.checkForPendingSr();
    if (hasPending) {
      return;
    }
    //shot form 2 for support and in-kind support
    this.showSupportServiceForm = true;
    this.srDetailLoading = false;
    if (!this.srNumber) {
      const requestPayload = this.buildRequestPayload('SAVE_CLOSE');
      this.submitSrData(requestPayload, SrActionType.DRAFT);
    }
    this.evaluateBusinessSupportVisibility();
  }

  onBankChange(event: any) {
    if (event?.selectedLov?.Value === FieldValue.OTHER_BANK || event?.selectedLov?.Value === FieldValue.OTHER_BANK_AR) {
      this.form.get('otherBankName')?.setValidators([Validators.required, Validators.maxLength(150)]);
    }
  }

  private buildRequestPayload(action: 'SUBMIT' | 'SAVE_CLOSE'): ChamberEntrepreneurshipRequest {
    const formValue = this.form.getRawValue();
    const request = new ChamberEntrepreneurshipRequest();
    request.body.DCMethod = action === 'SUBMIT' ? 'SUBMIT' : 'SAVEASDRAFT';
    request.body.DCLanguage = this.lang === 'ar' ? 'ARA' : 'ENU';
    request.body.DCLoginName = this.userLoginName;
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    const serviceRequest = request.body.DCIncomingHierarchy['ListOfDCDCEIO']['Service Request'];
    serviceRequest.CSN = formValue.tradeLicenseOrMembershipNumber ?? '';
    serviceRequest['Created By First Name'] = formValue.firstName ?? '';
    serviceRequest['SR Type'] = ServiceName.CHAMBER_ENTREPRENEURS;
    serviceRequest['SR Sub Type'] = ServiceName.CHAMBER_ENTREPRENEURS;
    serviceRequest['SR Number'] = this.srNumber ?? '';
    serviceRequest['Created By Last Name'] = formValue.lastName ?? '';
    serviceRequest['Created By Name'] =
      `${formValue.firstName ?? ''} ${formValue.lastName ?? ''}`.trim();
    serviceRequest['DC BGBCAssoc Venue'] = formValue.emiratesIdNumber ? formValue.emiratesIdNumber.replace(/-/g, '') : "";
    serviceRequest['DC Holder Mobile'] = `${formValue.mobileCountryCode ?? ''}${formValue.mobileNumber ?? ''}`;
    serviceRequest['DC CRB Primary Email'] = formValue.email ?? '';
    serviceRequest['DC SVS Other Member Number'] = formValue.tradeLicenseOrMembershipNumber ?? '';
    serviceRequest['DC Respondent Member Name'] = formValue.tradeNameEnglish ?? '';
    serviceRequest['DC Respondant Name Ara'] = formValue.tradeNameArabic ?? '';
    serviceRequest['DC Respondant Country'] = formValue.companyNationality ?? '';
    serviceRequest['DC License Issue Date'] = this.formatDateFromGroup(formValue.licenseIssueDate);
    serviceRequest['DC License Expiry Date'] = this.formatDateFromGroup(formValue.licenseExpiryDate);
    serviceRequest.Description = formValue.briefBusinessDescription ?? '';
    serviceRequest['DC FAC No of Guest'] = formValue.numberOfEmployees ?? '';
    serviceRequest['DC Kiosk Print Flag'] = formValue.otherTradeLicensesUae && (formValue.otherTradeLicensesUae == FieldValue.YES || formValue.otherTradeLicensesUae == FieldValue.YES_AR) ? 'Y' : 'N';
    serviceRequest['DC MRM Website'] = formValue.companyWebsite ?? '';
    serviceRequest['DC Account Holder'] = formValue.accountHolderName ? formValue.accountHolderName : this.memberDetail['DC Bank Account Holder'];
    let bankName = "";
    if (formValue?.bankName === FieldValue.OTHER_BANK || formValue?.bankName === FieldValue.OTHER_BANK_AR) {
      bankName = formValue.otherBankName;
    } else {
      bankName = formValue.bankName;
    }

    serviceRequest['DC Holder Bank Name'] = bankName ? bankName : this.memberDetail['DC Bank Name']; //formValue.bankName ?? '';
    serviceRequest['DC BGBCAssoc Bank Accnt Num'] = formValue.accountNumber ? formValue.accountNumber : this.memberDetail['DC Bank Account Number'];
    serviceRequest['DC IBAN No'] = normalizeIban(
      formValue.companyIban ? formValue.companyIban : this.memberDetail['DC Bank IBAN No']
    );
    serviceRequest['DC Swift Code'] = formValue.swiftCode ? formValue.swiftCode : this.memberDetail['DC Bank Swift Code'];

    const supportValue = this.supportForm.getRawValue();
    serviceRequest['DC FAC Insurance Amt'] = supportValue.tradeLicenseCost ?? '';
    serviceRequest['DC FAC Amt Pre Discount'] = supportValue.visaProcessingCost ?? '';
    serviceRequest['DC Amount in AED'] = supportValue.dewaCost ?? '';
    serviceRequest['DC CSR Mail Flag'] = supportValue.vatSupport && (supportValue.vatSupport == FieldValue.YES || supportValue.vatSupport == FieldValue.YES_AR) ? 'Y' : 'N';
    serviceRequest['DC Additional Detail'] = supportValue.marketInsights ?? '';
    serviceRequest['DC Reprint Sticker Flag'] = supportValue.aiCyberTraining && (supportValue.aiCyberTraining == FieldValue.YES || supportValue.aiCyberTraining == FieldValue.YES_AR) ? 'Y' : 'N';
    serviceRequest['ListOfDC DCE Question BC'] = this.buildDceQuestionList(supportValue);

    return request;
  }

  get formProgress() {
    if (!this.showSupportServiceForm) {
      if (this.form.disabled) {
        return 100;
      }
      if (!this.form.invalid && !this.checkRequiredDocuments()) {
        return 100;
      }
      return Utils.calculateFormProgress(this.step, this.totalSteps);
    }
    if (this.supportForm.disabled) {
      return 100;
    }
    if (!this.supportForm.invalid && !this.checkRequiredSupportDocuments()) {
      return 100;
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps);
  }

  private getDateFromGroup(group: FormGroup | null): Date | null {
    if (!group) {
      return null;
    }
    const day = group.get('day')?.value;
    const month = group.get('month')?.value;
    const year = group.get('year')?.value;
    if (!day || !month || !year) {
      return null;
    }
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  private formatDateFromGroup(value: any): string {
    if (!value) {
      return '';
    }
    const day = value?.day;
    const month = value?.month;
    const year = value?.year;
    if (!day || !month || !year) {
      return '';
    }
    const dd = String(day).padStart(2, '0');
    const mm = String(month).padStart(2, '0');
    const yyyy = String(year);
    return `${mm}/${dd}/${yyyy}`;
  }

  private buildDceQuestionList(supportValue: any) {
    const questions: any[] = [];
    const inKindAnswers = this.mapSelectedAnswers(
      supportValue?.trainingWorkshops,
      this.trainingWorkshopsOptions
    );
    if (inKindAnswers.length) {
      questions.push(
        this.createDceQuestion(
          'InKind Support',
          this.getEnglishTranslation('TRAINING_WORKSHOPS_QUESTION'),
          inKindAnswers
        )
      );
    }

    const strategicAnswers = this.mapSelectedAnswers(
      supportValue?.strategicPrograms,
      this.strategicProgramsOptions
    );
    if (strategicAnswers.length) {
      questions.push(
        this.createDceQuestion(
          'Strategic Support',
          this.getEnglishTranslation('STRATEGIC_PROGRAMS_QUESTION'),
          strategicAnswers
        )
      );
    }

    const serviceAnswers = this.mapSelectedAnswers(
      supportValue?.serviceSupport,
      this.serviceSupportOptions
    );
    if (serviceAnswers.length) {
      questions.push(
        this.createDceQuestion(
          'Strategic Support',
          this.getEnglishTranslation('SERVICE_SUPPORT_QUESTION'),
          serviceAnswers
        )
      );
    }

    return questions.length
      ? { 'DC DCE Question BC': questions }
      : { 'DC DCE Question BC': null }
  }

  private mapSelectedAnswers(selected: any, options: any[]): { en: string; ar: string }[] {
    const selectedValues = Array.isArray(selected) ? selected : [];
    return selectedValues
      .map((value: any) => {
        const option = (options || []).find((o: any) => o.value === value);
        const en = option?.description ?? option?.label ?? value ?? '';
        const ar = option?.high ?? '';
        return { en, ar };
      })
      .filter((item) => item.en || item.ar);
  }

  private createDceQuestion(
    supportType: string,
    question: string,
    answers: { en: string; ar: string }[]
  ) {
    return {
      'DC Support Type': supportType,
      'DC Question': question,
      'ListOfDC DCE Inkind Support BC': {
        'DC DCE Inkind Support BC': answers.map((answer) => ({
          'DC Value En': answer.en,
          'DC Value Ar': answer.ar
        }))
      }
    };
  }

  private getLicIssueMinDate(): Date | null {
    const licIssueParam = (this.dcParamsOptions || []).find(
      (item: any) => item?.name === 'LIC_ISSUE_DT'
    );
    const value = licIssueParam?.value;
    if (!value || typeof value !== 'string') {
      return null;
    }
    const parts = value.split('/');
    if (parts.length !== 3) {
      return null;
    }
    const [day, month, year] = parts.map((p) => Number(p));
    if (!day || !month || !year) {
      return null;
    }
    return new Date(year, month - 1, day);
  }

  private normalizeText(value: any): string {
    return (value ?? '').toString().trim().toLowerCase();
  }

  // This method is used to check member license issuing authority
  private isDetLicenseAuthority(): boolean {
    const authority = this.normalizeText(this.memberDetail?.['DC License Issue Authority']);
    return authority === this.normalizeText(FieldValue.DET);
  }

  // This method is used to check ower/partner nationality should be UAE
  private isUaeNationality(nationality: any): boolean {
    const normalizedNationality = this.normalizeText(nationality);
    if (
      normalizedNationality === this.normalizeText(FieldValue.UAE) ||
      normalizedNationality === this.normalizeText(FieldValue.UAE_AR)
    ) {
      return true;
    }
    return false;
  }

  // This method is used to check licuse issue date with LOV cout-off date
  private validateLicenseIssueDateCutoff(): boolean {
    const issueDate = this.getDateFromGroup(
      this.form.get('licenseIssueDate') as FormGroup
    );
    const cutOffDate = this.getLicIssueMinDate();
    if (issueDate && cutOffDate) {
      this.licIssueMinDate = cutOffDate;
      issueDate.setHours(0, 0, 0, 0);
      cutOffDate.setHours(0, 0, 0, 0);
      if (issueDate < cutOffDate) {
        this.licenseIssueDateInvalid = true;
        this.form.get('licenseIssueDate.day')?.markAsTouched();
        this.form.get('licenseIssueDate.month')?.markAsTouched();
        this.form.get('licenseIssueDate.year')?.markAsTouched();
        return false;
      }
    }
    this.licenseIssueDateInvalid = false;
    return true;
  }

  // This method is used to check ower/partners exist and nationaliy UAE
  private validateOwnerPartnerNationality(): boolean {
    const relationships = Utils.checkIsArray(this.memberDetail?.['Party Relationship To']);
    if (!relationships.length) {
      return true;
    }
    const ownerPartners = relationships.filter((relation: any) => {
      const relationshipType = this.normalizeText(relation?.['Relationship Type']).replace(/\s+/g, '');
      return (
        relationshipType === 'owner' ||
        relationshipType === 'shares owner' ||
        relationshipType === 'owner/partner' ||
        relationshipType === 'partner'
      );
    });
    if (!ownerPartners.length) {
      return true;
    }
    const invalidOwner = ownerPartners.find((owner: any) =>
      !this.isUaeNationality(owner?.['DC Cust Nationality'])
    );
    if (invalidOwner) {
      this.ownerPartnerNationalityInvalid = true;
      return false;
    }
    return true;
  }

  // This method is use dot validate member
  private validateSelectedMemberForNextStep(): boolean {
    if (!this.memberDetail) {
      return true;
    }
    this.licenseIssueDateInvalid = false;
    this.detLicenseAuthorityInvalid = false;
    this.ownerPartnerNationalityInvalid = false;
    if (!this.isDetLicenseAuthority()) {
      this.detLicenseAuthorityInvalid = true;
      return false;
    }
    if (!this.validateLicenseIssueDateCutoff()) {
      return false;
    }
    if (!this.validateOwnerPartnerNationality()) {
      return false;
    }
    return true;
  }

  private getEnglishTranslation(key: string): string {
    let listOfQuestions = [{
      "key": "TRAINING_WORKSHOPS_QUESTION",
      "value": "Which specialized training workshops would be most relevant to your business?"
    },
    {
      "key": "STRATEGIC_PROGRAMS_QUESTION",
      "value": "What strategic support program(s) you want to opt in for?"
    },
    {
      "key": "SERVICE_SUPPORT_QUESTION",
      "value": "Do you need support in accessing any of the below services?"
    }];
    const questionObj = listOfQuestions.find(q => q.key === key);
    return questionObj ? questionObj.value : key;
  }

  //Master Reimburse limit
  getReimburseLimit(name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'): string {
    const match = (this.dcParamsOptions || []).find(
      (item: any) => item?.name === name
    );
    return match?.value ?? '';
  }

  getMasterLimitFormatted(
    name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'
  ): string {
    const raw = this.getReimburseLimit(name);
    const limit = this.parseNumber(raw);
    if (limit == null) {
      return raw ?? '';
    }
    return new Intl.NumberFormat('en-US').format(limit);
  }

  getReimburseLimitFormatted(
    name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'
  ): string {
    const raw = this.getReimburseLimit(name);
    const limit = this.parseNumber(raw);
    if (limit == null) {
      return raw ?? '';
    }
    const used = this.getMemberReimbursedAmount(name);
    const remaining = used == null ? limit : Math.max(limit - used, 0);
    return new Intl.NumberFormat('en-US').format(remaining);
  }

  private getMemberReimbursedAmount(
    name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'
  ): number | null {
    if (!this.memberDetail) {
      return null;
    }
    if (name === 'LIC_REIMBURSE_LIMIT') {
      return this.parseNumber(this.memberDetail?.['DC DCE License Reimbursed Amt']);
    }
    if (name === 'VISA_REIMBURSE_LIMIT') {
      return this.parseNumber(this.memberDetail?.['DC DCE Visa Reimbursed Amt']);
    }
    if (name === 'UTILITY_REIMBURSE_LIMIT') {
      return this.parseNumber(this.memberDetail?.['DC DCE Utility Reimbursed Amt']);
    }
    return null;
  }

  // This method is used to search member
  handleSearch(searchText: any) {
    this.search$.next(searchText);
  }

  // This method is use to set the selected member
  updateMemberNumber(option: any) {
    if (option?.selectedLov) {
      const selectedLov = option.selectedLov;
      const memberNumber = selectedLov.CSN || '';
      this.form.get('tradeLicenseOrMembershipNumber')?.setValue(memberNumber);
      if (selectedLov.CSN) {
        this.selectedMemberCSN = selectedLov.CSN;
        this.getMemberDetail();
      }
    } else {
      this.form.get('tradeLicenseOrMembershipNumber')?.setValue('');
      this.selectedMemberCSN = '';
    }
  }

  // This method is used to get members using term and search by
  getMembers(term: string = '', searchBy: string = '') {
    return this.sharedService.getDCAllMembers(term, searchBy);
  }

  // This method is used to get lovs based on key
  private loadLovOptions(lovType: LookupKey, targetKey: 'trainingWorkshopsOptions' | 'strategicProgramsOptions' | 'serviceSupportOptions' | 'dcParamsOptions'): void {
    this.lookupService.post<LOVResponseModel>(LookupKey.LOOKUP_URL, {
      ProcessName: 'DC Get List Of Values WF',
      Type: lovType,
      LanguageCode: this.lang === 'ar' ? 'ARA' : 'ENU',
      ParentValue: ''
    }).subscribe({
      next: (response: LOVResponseModel) => {
        if (response?.SiebelMessage?.['List Of Values'] && !response['Error Message']) {
          const lovList = Utils.checkIsArray(response.SiebelMessage['List Of Values']);
          this[targetKey] = lovList.map((item: any) => ({
            label: this.lang == 'en' ? item['Description'] : item['High'],
            value: item['Value'] ?? item['Name'],
            name: item['Name'],
            high: item['High']
          }));
          if (targetKey === 'dcParamsOptions') {
            this.applyAmountLimits();
            // this.evaluateBusinessSupportVisibility();
          }
        } else {
          this[targetKey] = [];
        }
      },
      error: () => {
        this[targetKey] = [];
      }
    });
  }

  // This method is used to update the limi in form control
  private applyAmountLimits(): void {
    const licLimit = this.getRemainingReimburseLimit('LIC_REIMBURSE_LIMIT');
    const visaLimit = this.getRemainingReimburseLimit('VISA_REIMBURSE_LIMIT');
    const utilityLimit = this.getRemainingReimburseLimit('UTILITY_REIMBURSE_LIMIT');

    const tradeControl = this.supportForm.get('tradeLicenseCost');
    const visaControl = this.supportForm.get('visaProcessingCost');
    const utilityControl = this.supportForm.get('dewaCost');
    if (tradeControl && licLimit != null) {
      tradeControl.setValidators([Validators.max(licLimit)]);
      tradeControl.updateValueAndValidity({ emitEvent: false });
    }
    if (visaControl && visaLimit != null) {
      visaControl.setValidators([Validators.max(visaLimit)]);
      visaControl.updateValueAndValidity({ emitEvent: false });
    }
    if (utilityControl && utilityLimit != null) {
      utilityControl.setValidators([Validators.max(utilityLimit)]);
      utilityControl.updateValueAndValidity({ emitEvent: false });
    }
  }

  private getRemainingReimburseLimit(
    name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'
  ): number | null {
    const limit = this.getReimburseLimitNumber(name);
    if (limit == null) {
      return null;
    }
    const used = this.getMemberReimbursedAmount(name);
    if (used == null) {
      return limit;
    }
    return Math.max(limit - used, 0);
  }

  private getReimburseLimitNumber(
    name: 'LIC_REIMBURSE_LIMIT' | 'VISA_REIMBURSE_LIMIT' | 'UTILITY_REIMBURSE_LIMIT'
  ): number | null {
    const raw = this.getReimburseLimit(name);
    return this.parseNumber(raw);
  }

  private evaluateBusinessSupportVisibility(): void {
    if (!this.memberDetail) {
      this.showBusinessSupportSections = true;
      return;
    }
    const startDate = this.memberDetail?.['DC DCE Start Date'];
    if (!startDate) {
      this.showBusinessSupportSections = true;
      return;
    }

    //this.showEntrepreneurshipForm = !this.showActions;
    this.showSupportServiceForm = true;
    // if no amount that means
    if (this.srNumber && this.memberDetail?.['DC DCE Start Date'] &&
      this.memberDetail?.['DC DCE License Reimbursed Amt'] > 0 &&
      !this.requestDetail['DC FAC Insurance Amt'] &&
      !this.requestDetail['DC FAC Amt Pre Discount'] &&
      !this.requestDetail['DC Amount in AED']) {
      this.showEntrepreneurshipForm = false;
    }
    if (this.showSupportServiceForm) {
      this.form.disable();
    }
    this.hideShowLienseAndVisaField();
  }

  // This method is used to hide/show and disable the business support section
  hideShowLienseAndVisaField() {
    const licAmt = this.parseNumber(this.memberDetail?.['DC DCE License Reimbursed Amt']);
    const visaAmt = this.parseNumber(this.memberDetail?.['DC DCE Visa Reimbursed Amt']);
    const utilityAmt = this.parseNumber(this.memberDetail?.['DC DCE Utility Reimbursed Amt']);
    const utilityLimit = this.getReimburseLimitNumber('UTILITY_REIMBURSE_LIMIT');

    const tradeControl = this.supportForm.get('tradeLicenseCost');
    const visaControl = this.supportForm.get('visaProcessingCost');
    if (licAmt && licAmt > 0) {
      tradeControl?.disable({ emitEvent: false });
    } else if (this.showActions) {
      tradeControl?.enable({ emitEvent: false });
    }
    if (visaAmt && visaAmt > 0) {
      visaControl?.disable({ emitEvent: false });
    } else if (this.showActions) {
      visaControl?.enable({ emitEvent: false });
    }

    const allHaveValues = licAmt != null && visaAmt != null && utilityAmt != null;
    if (allHaveValues && utilityLimit != null && utilityAmt >= utilityLimit) {
      this.showBusinessSupportSections = false;
    } else {
      this.showBusinessSupportSections = true;
    }
  }
  private parseNumber(value: any): number | null {
    if (value == null || value === '') {
      return null;
    }
    const numeric = Number(value.toString().replace(/,/g, '').trim());
    return Number.isFinite(numeric) ? numeric : null;
  }

  private getYesNoValue(flag: string | null | undefined): string {
    if (!flag) {
      return '';
    }
    if (flag === 'Y') {
      return this.lang === 'ar' ? FieldValue.YES_AR : FieldValue.YES;
    }
    if (flag === 'N') {
      return this.lang === 'ar' ? FieldValue.NO_AR : FieldValue.NO;
    }
    return flag;
  }

  // get folder id and attachments
  openFolder() {
    this.loadingDoc = true;
    const isLabels = !this.srNumber;
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.ENTPR, isLabels)
      .subscribe({
        next: (response: any) => {
          if (response.success) {
            this.loadingDoc = false;
            this.srFolder = response.data ? response.data : response;
            const allDocs = this.srFolder.allowedDocumentTypes?.filter(
              (d: AllowedDocumentType) => !d.forUISection
            ) || [];
            const supportDocNames = [
              'Trade License Receipt',
              'Visa Processing Receipt',
              'Utility Bills Support'
            ];
            this.supportFormDocs = allDocs.filter(
              (doc) => supportDocNames.includes(doc?.nameEn || '')
            );
            this.mainFromSectionDocs = allDocs.filter(
              (doc) => !supportDocNames.includes(doc?.nameEn || '')
            );
            this.mainFromSectionDocs = this.mainFromSectionDocs.map((doc) => ({
              ...doc,
              mandatory: true
            }));
          } else {
            this.loadingDoc = false;
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        },
        error: err => {
          this.loadingDoc = false;
          this.sharedService.toastMessage("error", err, 'error');
        }
      });
  }

  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }
    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      if (!cmp) continue;
      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  private getSupportDocControlName(docName: string | null | undefined): 'tradeLicenseCost' | 'visaProcessingCost' | 'dewaCost' | null {
    if (!docName) {
      return null;
    }
    if (docName === 'Trade License Receipt') {
      return 'tradeLicenseCost';
    }
    if (docName === 'Visa Processing Receipt') {
      return 'visaProcessingCost';
    }
    if (docName === 'Utility Bills Support') {
      return 'dewaCost';
    }
    return null;
  }

  private isSupportFieldVisible(controlName: 'tradeLicenseCost' | 'visaProcessingCost' | 'dewaCost'): boolean {
    const control = this.supportForm.get(controlName);
    if (!this.showActions && !control?.value) {
      return false;
    }
    if (this.showActions && control?.disabled) {
      return false;
    }
    return true;
  }

  get showTradeLicenseCostField(): boolean {
    return this.isSupportFieldVisible('tradeLicenseCost');
  }

  get showVisaProcessingCostField(): boolean {
    return this.isSupportFieldVisible('visaProcessingCost');
  }

  get showDewaCostField(): boolean {
    return this.isSupportFieldVisible('dewaCost');
  }

  shouldShowSupportDoc(doc: AllowedDocumentType): boolean {
    const controlName = this.getSupportDocControlName(doc?.nameEn);
    if (!controlName) {
      return true;
    }
    return this.isSupportFieldVisible(controlName);
  }

  isSupportDocRequired(doc: AllowedDocumentType): boolean {
    const controlName = this.getSupportDocControlName(doc?.nameEn);
    if (!controlName) {
      return false;
    }
    const control = this.supportForm.get(controlName);
    const value = control?.value;
    return value != null && value !== '';
  }

  private checkRequiredSupportDocuments(): boolean {
    if (!this.supportFormDocs || this.supportFormDocs.length === 0) {
      return false;
    }
    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];
    let hasMissing = false;
    for (const doc of this.supportFormDocs) {
      if (!this.isSupportDocRequired(doc) || !this.shouldShowSupportDoc(doc)) {
        continue;
      }
      const cmp = fileCmps.find((c: any) => c?.documentType === doc?.nameEn);
      if (!cmp || (typeof cmp.checkMissing === 'function' && cmp.checkMissing(true))) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }

  visibleCompanyDetail: boolean = true;
  visibleBankAccountDetail: boolean = true
  // This method is used to get member detail
  getMemberDetail() {
    this.licenseIssueDateInvalid = false;
    if (!this.selectedMemberCSN) {
      return;
    }
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Member Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.CHAMBER_ENTREPRENEURSHIP,
        "IOName": "DC Get Acc Details IO",
        "CSN": this.selectedMemberCSN
      }
    }
    this.api.post(ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_MEMBER_DETAIL_BY_CSN,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response["Error Code"] == "" && response["Error Message"] == "" && response["SiebelMessage"]) {
          if (response["SiebelMessage"]['DC Account Data Transfer']) {
            this.memberDetail = response["SiebelMessage"]['DC Account Data Transfer'];
            const issueDate = this.memberDetail["DC License Issue Date"]
              ? new Date(this.memberDetail["DC License Issue Date"])
              : null;
            const expiryDate = this.memberDetail["DC License Expiry Date"]
              ? new Date(this.memberDetail["DC License Expiry Date"])
              : null;

            this.form.patchValue(
              {
                tradeNameEnglish: this.memberDetail["DC Name English"] || '',
                tradeNameArabic: this.memberDetail["DC Name Arabic"] || '',
                companyNationality: this.memberDetail["DC Country"] || '',
                licenseIssueDate: {
                  day: issueDate ? issueDate.getDate().toString().padStart(2, '0') : null,
                  month: issueDate ? (issueDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: issueDate ? issueDate.getFullYear() : null,
                },
                licenseExpiryDate: {
                  day: expiryDate ? expiryDate.getDate().toString().padStart(2, '0') : null,
                  month: expiryDate ? (expiryDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: expiryDate ? expiryDate.getFullYear() : null,
                }
              },
              { emitEvent: false }
            );
            this.applyAmountLimits();
            // const startDate = this.memberDetail?.['DC DCE Start Date'];
            // if (!this.srNumber && startDate && this.showActions) {
            //   this.showEntrepreneurshipForm = false;
            //   this.showBusinessSupportSections = true;
            //   this.showSupportServiceForm = true;
            //   this.hideShowLienseAndVisaField();
            // }
            if (this.srNumber) {
              let srStatus = this.requestStatus;
              if (this.memberDetail['DC DCE Start Date'] && srStatus != SrStatus.Draft && srStatus != SrStatus.AwaitingClarification && srStatus != SrStatus.Approved) {
                this.showActions = false;
                this.supportForm.disable();
              }
              this.evaluateBusinessSupportVisibility();
            }
          }
        } else {
          this.sharedService.toastMessage("error", '', 'error', response["Error Message"]);
        }
      },
      error: () => {
      }
    })
  }

  // This method is used to get SR detail
  requestDetail: any = "";
  requestStatus: string = "";
  getSrDetail() {
    if (!this.srNumber) {
      return;
    }
    const requestPayload = {
      body: {
        ProcessName: 'DC Community Portal SR Process Wrapper WF',
        DCMethod: 'QUERY',
        DCLanguage: this.lang === 'ar' ? 'ARA' : 'ENU',
        DCLoginName: this.userLoginName,
        DCIncomingHierarchy: {
          MessageId: Utils.generateUniqueId(),
          IntObjectName: 'DCDCEIO',
          MessageType: 'Integration Object',
          IntObjectFormat: 'Siebel Hierarchical',
          ListOfDCDCEIO: {
            'Service Request': {
              'CSN': "",
              'Created By First Name': '',
              'Created By Last Name': '',
              'Created By Name': '',
              'SR Type': ServiceName.CHAMBER_ENTREPRENEURS,
              'SR Sub Type': ServiceName.CHAMBER_ENTREPRENEURS,
              'SR Number': this.srNumber
            }
          }
        }
      }
    };
    this.srDetailLoading = true;
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.DCE_CREATE_SR, requestPayload)
      .subscribe({
        next: (response: any) => {
          this.srDetailLoading = false;
          if (response && response['Error Code'] == null && response?.SiebelMessage?.['Service Request']) {
            const serviceRequest = response?.SiebelMessage?.['Service Request'] || response?.SiebelMessage?.['DC Community Portal SR'];
            if (!serviceRequest) {
              return;
            }
            this.requestDetail = serviceRequest;
            this.requestStatus = response['DCSRStatus'] || '';
            let srStatus = response['DCSRStatus'] || '';
            const mobileRaw = serviceRequest['DC Holder Mobile'] || '';
            const mobileCountryCode = mobileRaw ? Utils.parseMobile(mobileRaw, 'cc') : '';
            const mobileNumber = mobileRaw ? Utils.parseMobile(mobileRaw, 'number') : '';

            const issueDate = serviceRequest['DC License Issue Date']
              ? new Date(serviceRequest['DC License Issue Date'])
              : null;
            const expiryDate = serviceRequest['DC License Expiry Date']
              ? new Date(serviceRequest['DC License Expiry Date'])
              : null;

            let loginUserDetail = this.sharedService.getUserProfile();
            const hasPhone = !!loginUserDetail?.['Phone #'];
            const userMobileNumber = hasPhone
              ? Utils.parseMobile(loginUserDetail['Phone #'], 'number')
              : '';
            const userMobileCountryCode = hasPhone
              ? Utils.parseMobile(loginUserDetail['Phone #'], 'cc')
              : '';

            this.form.patchValue(
              {
                firstName: serviceRequest['Created By First Name'] || loginUserDetail?.['First Name'],
                lastName: serviceRequest['Created By Last Name'] || loginUserDetail?.['Last Name'],
                emiratesIdNumber: serviceRequest['DC BGBCAssoc Venue'] || loginUserDetail?.['Emirates Id'],
                mobileCountryCode: mobileCountryCode || userMobileCountryCode,
                mobileNumber: mobileNumber || userMobileNumber,
                email: serviceRequest['DC CRB Primary Email'] || loginUserDetail?.['EMail Addr'],
                tradeLicenseOrMembershipNumber: serviceRequest['DC Member Number'] || serviceRequest['DC SVS Other Member Number'] || '',
                tradeNameEnglish: serviceRequest['DC Respondent Member Name'] || '',
                tradeNameArabic: serviceRequest['DC Respondant Name Ara'] || '',
                companyNationality: serviceRequest['DC Respondant Country'] || '',
                licenseIssueDate: {
                  day: issueDate ? issueDate.getDate().toString().padStart(2, '0') : null,
                  month: issueDate ? (issueDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: issueDate ? issueDate.getFullYear() : null,
                },
                licenseExpiryDate: {
                  day: expiryDate ? expiryDate.getDate().toString().padStart(2, '0') : null,
                  month: expiryDate ? (expiryDate.getMonth() + 1).toString().padStart(2, '0') : null,
                  year: expiryDate ? expiryDate.getFullYear() : null,
                },
                briefBusinessDescription: serviceRequest['Description'] || '',
                numberOfEmployees: serviceRequest['DC FAC No of Guest'] || '',
                otherTradeLicensesUae: this.getYesNoValue(serviceRequest['DC Kiosk Print Flag']),
                companyWebsite: serviceRequest['DC MRM Website'] || '',
                bankName: serviceRequest['DC Holder Bank Name'] || '',
                accountHolderName: serviceRequest['DC Account Holder'] || '',
                accountNumber: serviceRequest['DC BGBCAssoc Bank Accnt Num'] || '',
                companyIban: normalizeIban(serviceRequest['DC IBAN No']),
                swiftCode: serviceRequest['DC Swift Code'] || '',
                confirmInformation: "Yes"
              },
              { emitEvent: false }
            );
            this.supportForm.patchValue(
              {
                tradeLicenseCost: serviceRequest['DC FAC Insurance Amt'] || '',
                visaProcessingCost: serviceRequest['DC FAC Amt Pre Discount'] || '',
                dewaCost: serviceRequest['DC Amount in AED'] || '',
                vatSupport: this.getYesNoValue(serviceRequest['DC CSR Mail Flag']),
                marketInsights: serviceRequest['DC Additional Detail'] || '',
                aiCyberTraining: this.getYesNoValue(serviceRequest['DC Reprint Sticker Flag'])
              },
              { emitEvent: false }
            );
            this.selectedMemberCSN = serviceRequest['DC Member Number'] || serviceRequest['DC SVS Other Member Number'] || '';
            const questions = Utils.checkIsArray(serviceRequest['DC DCE Question BC']);
            this.patchSupportSelectionsFromQuestions(questions);
            this.getMemberDetail();

            this.step = (srStatus == SrStatus.Draft ? 2 : this.totalSteps);

            if (srStatus != SrStatus.Draft && srStatus != SrStatus.AwaitingClarification) {
              // this.showActions = false;
              this.form.disable();
            }
            if (srStatus == SrStatus.Approved ||
              srStatus == SrStatus.PendingApproval ||
              srStatus == SrStatus.Closed ||
              srStatus == SrStatus.ApprovedAndPaymentAwaited
            ) {
              this.showSupportServiceForm = true;
              this.showEntrepreneurshipForm = false;
              if (srStatus == SrStatus.Closed || srStatus == SrStatus.PendingApproval) {
                this.showEntrepreneurshipForm = true;
                this.showActions = false;
                this.supportForm.disable();
                if (!serviceRequest['DC FAC Insurance Amt'] && !serviceRequest['DC FAC Amt Pre Discount'] &&
                  !serviceRequest['DC Amount in AED']) {
                  this.showEntrepreneurshipForm = false;
                }
              }
            } else {
              this.showSupportServiceForm = false;
              this.showEntrepreneurshipForm = true;

              if (srStatus == SrStatus.Draft || srStatus == SrStatus.AwaitingClarification) {
                this.showActions = true;
              } else {
                this.showActions = false;
                this.form.disable();
                this.supportForm.disable();
              }
            }

            const isEditableStatus =
              srStatus === SrStatus.Draft ||
              srStatus === SrStatus.AwaitingClarification;

            this.visibleCompanyDetail = isEditableStatus;
            this.visibleBankAccountDetail = isEditableStatus;

            // if (
            //   !serviceRequest['Description']) {
            //   this.visibleCompanyDetail = false;
            // }

            // if (
            //   (
            //     !serviceRequest['DC Holder Bank Name'] ||
            //     !serviceRequest['DC Account Holder'] ||
            //     !serviceRequest['DC BGBCAssoc Bank Accnt Num'] ||
            //     !serviceRequest['DC IBAN No']
            //   )
            // ) {
            //   this.visibleBankAccountDetail = false;
            // }

            if (this.sharedService.enableNotesOption(srStatus)) {
              this.srInprgoressAwating = true;
              this.showNotes = true;
            }
          } else {
            this.technicalErrorMsg = true
          }
        },
        error: () => {
          this.srDetailLoading = false;
        }
      });
  }

  private patchSupportSelectionsFromQuestions(questions: any[]): void {
    if (!questions || questions.length === 0) {
      return;
    }

    const extractAnswers = (q: any): string[] => {
      const inkind = q?.['DC DCE Inkind Support BC'];
      const list = Utils.checkIsArray(inkind);
      return list.map((item: any) => {
        const en = item?.['DC Value En'];
        const ar = item?.['DC Value Ar'];
        return this.lang === 'ar' ? (ar || en || '') : (en || ar || '');
      }).filter((v: string) => !!v);
    };

    const trainingQuestion = questions.find((q: any) =>
      q?.['DC Question'] === this.getEnglishTranslation('TRAINING_WORKSHOPS_QUESTION')
    );
    const strategicQuestion = questions.find((q: any) =>
      q?.['DC Question'] === this.getEnglishTranslation('STRATEGIC_PROGRAMS_QUESTION')
    );
    const serviceQuestion = questions.find((q: any) =>
      q?.['DC Question'] === this.getEnglishTranslation('SERVICE_SUPPORT_QUESTION')
    );

    if (trainingQuestion) {
      this.supportForm.get('trainingWorkshops')?.setValue(extractAnswers(trainingQuestion));
    }
    if (strategicQuestion) {
      this.supportForm.get('strategicPrograms')?.setValue(extractAnswers(strategicQuestion));
    }
    if (serviceQuestion) {
      this.supportForm.get('serviceSupport')?.setValue(extractAnswers(serviceQuestion));
    }
  }

  private getStepFields(step: number): string[] {
    switch (step) {
      case 1:
        return [
          'firstName',
          'lastName',
          'emiratesIdNumber',
          'mobileNumber',
          'email'
        ];
      case 2:
        return [
          'tradeLicenseOrMembershipNumber',
          'tradeNameEnglish',
          'tradeNameArabic',
          'companyNationality',
          'licenseIssueDate',
          'licenseExpiryDate'
        ];
      case 3:
        return ['briefBusinessDescription', 'otherTradeLicensesUae'];
      case 4:
        return [
          'accountHolderName',
          'bankName',
          'accountNumber',
          'companyIban',
          'swiftCode'
        ];
      case 5:
        return ['confirmInformation'];
      default:
        return [];
    }
  }

  // This method is used to validate emirate id
  validateEmiratesId(emirateId: string) {
    if (!emirateId || !this.emiratesIdLookupRequired) {
      return;
    }
    this.emiratesIdChecking = true;
    this.emiratesIdChecked = false;
    this.emiratesIdFound = true;
    const requestPayload = {
      identityNumber: emirateId
    };
    this.api.post(
      ApiRoot.ICA_PERSON_INQUIRY,
      ApiEndPoints.GET_PERSON_INQUIRY,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        this.emiratesIdChecking = false;
        this.emiratesIdChecked = true;
        if (response && response.errorCode == null) {
          if (response.personProfileType) {
            let profile = response.personProfileType;
            this.emiratesIdFound = true;
          } else {
            this.emiratesIdFound = false;
          }
        } else {
          this.emiratesIdFound = false;
        }
      },
      error: () => {
        this.emiratesIdChecking = false;
        this.emiratesIdChecked = true;
        this.emiratesIdFound = false;
        this.cdr.detectChanges();
      }
    })
  }

  onEmiratesIdBlur(): void {
    if (!this.emiratesIdLookupRequired) {
      return;
    }
    const emiratesIdValue = this.form.get('emiratesIdNumber')?.value;
    if (!emiratesIdValue) {
      this.emiratesIdChecked = false;
      this.emiratesIdFound = true;
      return;
    }
    if (this.form.get('emiratesIdNumber')?.invalid) {
      return;
    }
    this.validateEmiratesId(emiratesIdValue);
  }

  async nextStep(): Promise<void> {
    this.licIssueMinDate = null;
    const stepFields = this.getStepFields(this.step);
    if (stepFields.some((f) => this.form.get(f)?.invalid)) {
      stepFields.forEach((f) => this.form.get(f)?.markAsTouched());
      return;
    }

    if (this.step === 1 && this.emiratesIdLookupRequired) {
      if (this.emiratesIdChecking) {
        return;
      }
      if (!this.emiratesIdChecked || !this.emiratesIdFound) {
        const emiratesIdValue = this.form.get('emiratesIdNumber')?.value;
        if (emiratesIdValue) {
          this.validateEmiratesId(emiratesIdValue);
        }
        this.form.get('emiratesIdNumber')?.markAsTouched();
        return;
      }
    }

    if (this.step >= 2) {
      if (!this.validateSelectedMemberForNextStep()) {
        return;
      }
      if (this.memberDetail?.['DC DCE Start Date']) {
        this.showEntrepreneurshipForm = false;

        const hasPending = await this.checkForPendingSr();
        if (hasPending) {
          return;
        }
        this.showSupportServiceForm = true;
        if (!this.srNumber && !this.licenseIssueDateInvalid) {
          const requestPayload = this.buildRequestPayload('SAVE_CLOSE');
          this.submitSrData(requestPayload, SrActionType.DRAFT);
        }
        this.evaluateBusinessSupportVisibility();
      } else {
        const hasPending = await this.checkForPendingSr();
        if (hasPending) {
          return;
        }
        if (!this.srNumber && !this.licenseIssueDateInvalid) {
          const requestPayload = this.buildRequestPayload('SAVE_CLOSE');
          this.submitSrData(requestPayload, SrActionType.DRAFT);
        }
      }
    }

    if (this.step >= 5) {
      this.submit();
      return;
    }

    this.step++;
  }

  isCheckingPendingSr: boolean = false;
  pendingSrNumber: string = "";
  pendingSrDetail: any = "";
  // This method is used to check for pending sr
  async checkForPendingSr(): Promise<boolean> {
    if (this.srNumber != "") {
      return false;
    }
    this.isCheckingPendingSr = true;
    try {
      const response: any = await new Promise((resolve, reject) => {
        this.sharedService.checkInprogressApplication(
          this.selectedMemberCSN,
          ServiceName.CHAMBER_ENTREPRENEURS,
          ServiceName.CHAMBER_ENTREPRENEURS
        ).subscribe({
          next: resolve,
          error: reject
        });
      });
      if (
        response["Error Code"] == null &&
        response["Error Message"] == null &&
        response?.SiebelMessage?.['DC Community Portal SR']
      ) {
        const srData = response?.SiebelMessage?.['DC Community Portal SR'];
        const srRecords = Array.isArray(srData) ? srData : [srData];
        const pendingSrNumbers = srRecords
          .map((sr: any) => sr?.['SR Number'])
          .filter(Boolean);
        if (pendingSrNumbers.length) {
          this.pendingSrNumber = pendingSrNumbers.join(', ');
          this.pendingSrDetail = Array.isArray(srData) ? srRecords : srData;
          return true;
        }
      }
      return false;
    } catch {
      return false;
    } finally {
      this.isCheckingPendingSr = false;
    }
  }

  // This method is used to close pending sr modal
  closependingSrModal() {
    this.pendingSrNumber = "";
    this.router.navigate([RoutesPath.DASHBOARD]);
  }


  saveAndClose() {
    this.form.markAllAsTouched();
    const requestPayload = this.buildRequestPayload('SAVE_CLOSE');
    this.submitSrData(requestPayload, SrActionType.SAVE);
  }

  submit() {
    if (!this.validateSelectedMemberForNextStep()) {
      return;
    }

    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    if (this.checkRequiredDocuments()) {
      this.sharedService.toastMessage('ERROR', 'FILL_REQUIRED_FIELDS_DOCUMENTS', 'error', false);
      return;
    }
    if (this.checkRequiredSupportDocuments()) {
      this.sharedService.toastMessage('ERROR', 'FILL_REQUIRED_FIELDS_DOCUMENTS', 'error', false);
      return;
    }
    const requestPayload = this.buildRequestPayload('SUBMIT');
    this.submitSrData(requestPayload, SrActionType.SUBMIT);
  }
  technicalErrorMsg: boolean = false;
  isSaved: boolean = false;
  successModal: boolean = false;
  formSubmitLoader: boolean = false;
  private isSrSubmitInProgress: boolean = false;
  private linkMemberInProgress: boolean = false;
  private linkedMembers = new Set<string>();
  submitSrData(requestPayload: any, actionType: string) {
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    let srSubType = ServiceName.CHAMBER_ENTREPRENEURS;
    if (this.isSrSubmitInProgress) {
      return;
    }

    this.technicalErrorMsg = false;
    if (!isActionDraft) {
      this.formSubmitLoader = true;
    }
    // if (this.showBusinessSupportSections && this.showSupportServiceForm && isActionSubmit) {
    //   requestPayload.body['DCMethod'] = "REIMBURSE";
    // }
    this.isSrSubmitInProgress = true;
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.DCE_CREATE_SR, requestPayload).subscribe({
      next: (response: any) => {
        if (response['Error Code'] == null && response["DCSRNumber"]) {
          this.isSaved = true;
          this.linkMember();
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["DCSRNumber"];
              sessionStorage.setItem("srNumber", response["DCSRNumber"]);
            } else {
              this.srNumber = response["DCSRNumber"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
            this.openFolder();
          } else {
            this.srNumber = response["DCSRNumber"];
            //set sr detail for success page to get ioname
            const { service, serviceAr } = Utils.getServiceLabels(srSubType, this.lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              mainService: ServiceName.SIGNATURE_OF_VERIFICATION,
              service: srSubType,
              IOName: SrIOName.ATTESTATION,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step + 1,
              feeAmount: response?.DCTotalFees
            }
            this.sharedService.setSrResponse(srDetailObj);
            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }
          this.formSubmitLoader = false;
          this.isSrSubmitInProgress = false;
        } else {
          this.formSubmitLoader = false;
          this.technicalErrorMsg = true;
          this.isSrSubmitInProgress = false;
        }
      },
      // This method is used to handle the error callback using e
      error: (e) => {
        this.technicalErrorMsg = true;
        this.formSubmitLoader = false;
        this.isSrSubmitInProgress = false;
      }
    });
  }

  // This method is used to link selected member to user if does not exist
  linkMember() {
    if (!this.selectedMemberCSN) {
      return;
    }
    if (this.linkedMembers.has(this.selectedMemberCSN) || this.linkMemberInProgress) {
      return;
    }
    let accounts = Utils.checkIsArray(this.sharedService.getUserProfile()?.Account) ?? [];
    let isMemberExist = accounts.some(acc => acc.CSN === this.selectedMemberCSN);
    if (isMemberExist) {
      this.linkedMembers.add(this.selectedMemberCSN);
      return;
    }
    const request = new LinkMemberRequest();
    request.body.DCMethod = "SUBMIT"; //SUBMIT 
    request.body.DCLoginName = this.userLoginName;
    request.body.DCLanguage = this.lang == 'ar' ? 'ARA' : 'ENU';
    request.body.DCIncomingHierarchy.MessageId = Utils.generateUniqueId();

    let srData = request.body.DCIncomingHierarchy["ListOfDC Community Portal SR Upsert IO"]["DC Community Portal SR"]
    srData['SR Number'] = "";
    srData["CSN"] = this.memberCSN;
    srData["SR Type"] = ServiceName.USER_MANAGEMENT;
    srData["Sub Type"] = ServiceName.USER_ACCESS;
    srData["DC Payment Method"] = this.lang == 'ar' ? FieldValue.PAYMENT_METHOD_ONLINE_AR : FieldValue.PAYMENT_METHOD_ONLINE_EN;
    srData["DC Channel"] = this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN;
    srData["DC Link CSN"] = this.selectedMemberCSN; //this.selectedCompany.CSN;
    srData["DC Link UserID"] = this.userLoginName;
    srData['DC Link Mem Answer1'] = "N"; //Owner
    srData['DC Link Mem Answer2'] = "N"; //Manager
    srData['DC Link Mem Answer3'] = "Y"; //Representative
    srData['DC Holder Mobile'] = this.sharedService.getUserProfile()?.['Phone #'] || '';
    this.linkMemberInProgress = true;
    this.api.post(
      ApiRoot.ATA_DC_SERVICE_REQUEST_INTEGRATION_API,
      ApiEndPoints.ATA_MANAGE_SERVICE_REQUEST,
      request
    ).subscribe({
      next: (response: any) => {
        if (response['Error Code'] == null && response["DCSRNumber"]) {
          this.linkedMembers.add(this.selectedMemberCSN);
        }
        this.linkMemberInProgress = false;
      },
      error: () => {
        this.linkMemberInProgress = false;
      }
    })
  }

  // Submit support form
  submitSupport() {
    this.supportForm.markAllAsTouched();
    this.showSupportAtLeastOneError = false;
    this.showInKindLeastOneError = false;
    if (this.supportForm.invalid) {
      return;
    }
    if (
      this.showBusinessSupportSections &&
      this.showTradeLicenseCostField &&
      this.showVisaProcessingCostField &&
      this.showDewaCostField
    ) {
      const tradeLicenseCost = this.supportForm.get('tradeLicenseCost')?.value;
      const visaProcessingCost = this.supportForm.get('visaProcessingCost')?.value;
      const dewaCost = this.supportForm.get('dewaCost')?.value;
      const hasAnyCost =
        (tradeLicenseCost != null && tradeLicenseCost !== '') ||
        (visaProcessingCost != null && visaProcessingCost !== '') ||
        (dewaCost != null && dewaCost !== '');
      if (!hasAnyCost) {
        this.showSupportAtLeastOneError = true;
        return;
      }
    }
    else if (
      this.showBusinessSupportSections &&
      this.showDewaCostField
    ) {
      const dewaCost = this.supportForm.get('dewaCost')?.value;
      const hasAnyCost =
        (dewaCost != null && dewaCost !== '');
      if (!hasAnyCost) {
        this.showSupportAtLeastOneError = true;
        return;
      }
    }
    else if (!this.showBusinessSupportSections) {
      const marketInsights = this.supportForm.get('marketInsights')?.value;
      const trainingWorkshops = this.supportForm.get('trainingWorkshops')?.value;
      const strategicPrograms = this.supportForm.get('strategicPrograms')?.value;
      const aiCyberTraining = this.supportForm.get('aiCyberTraining')?.value;
      const serviceSupport = this.supportForm.get('serviceSupport')?.value;
      const hasAnySupportValue =
        (marketInsights != null && marketInsights !== '') ||
        (Array.isArray(trainingWorkshops) && trainingWorkshops.length > 0) ||
        (Array.isArray(strategicPrograms) && strategicPrograms.length > 0) ||
        // (aiCyberTraining != null && aiCyberTraining !== '') ||
        (Array.isArray(serviceSupport) && serviceSupport.length > 0);
      if (!hasAnySupportValue) {
        this.showInKindLeastOneError = true;
        return;
      }
    }
    if (this.checkRequiredSupportDocuments()) {
      this.sharedService.toastMessage('ERROR', 'FILL_REQUIRED_FIELDS_DOCUMENTS', 'error', false);
      return;
    }
    const requestPayload = this.buildRequestPayload('SUBMIT');
    this.submitSrData(requestPayload, SrActionType.SUBMIT);
  }

  // This method is used to determine if deactivate
  canDeactivate(): boolean {
    return this.sharedService.confirmNavigationIfFormDirty(this.form, this.isSaved);
  }

  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }
  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
  }

}
